module.exports = __webpack_public_path__ + "static/media/End-of-Trial-Week-Message.6f3592db.jpg";